export const editMutations = <const>{
	NAHRADNI_SAZBA_MASKA_MODELU_SELECT_MAPPER: 'NAHRADNI_SAZBA_MASKA_MODELU_SELECT_MAPPER',
	NAHRADNI_SAZBA_VOZIDLO_PUJCOVNA_SELECT_MAPPER: 'NAHRADNI_SAZBA_VOZIDLO_PUJCOVNA_SELECT_MAPPER',
};
